module.exports = __webpack_public_path__ + "static/media/edited-icon.ca1b2a6f.svg";